import { j as t } from "../../jsx-runtime.BREq8dyb.js";
import { faInfoCircle as f } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as l } from "@fortawesome/react-fontawesome";
import { Tooltip as a, IconButton as x } from "@mui/joy";
const j = ({
  tooltip: i,
  size: e,
  height: r,
  marginLeft: n,
  top: m,
  placement: p,
  IconButtonProps: o = {},
  ...s
}) => /* @__PURE__ */ t.jsx(a, { placement: p, title: i, ...s, children: /* @__PURE__ */ t.jsx(x, { size: e, style: {
  height: r,
  marginLeft: n || "4px",
  minHeight: "auto",
  minWidth: "auto",
  padding: 4,
  position: "relative",
  top: m || "-2px",
  ...o.style || {}
}, ...o, children: /* @__PURE__ */ t.jsx(l, { fixedWidth: !0, icon: f }) }) });
export {
  j as default
};
//# sourceMappingURL=InfoTooltip.js.map
